import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { invoice_state } from '../../../../invoicing/data/invoice-states.service';
import { InvoicesListItem } from '../types';

type InvoiceTabId = 'all' | 'draft' | 'validation' | 'approved' | 'rejected' | 'overdue';

type InvoiceTab = {
  id: InvoiceTabId;
  stateId: number | null;
  label: string;
  className: string;
};

@Component({
  selector: 'dashboard-invoicing-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class DashboardInvoicingListComponent {
  @Input() invoices: InvoicesListItem[] = [];

  readonly tabs: InvoiceTab[] = [
    { id: 'all', stateId: null, label: 'Alles', className: 'all' },
    { id: 'draft', stateId: invoice_state.draft, label: 'Concept', className: 'draft' },
    { id: 'validation', stateId: invoice_state.validation, label: 'In validatie', className: 'validation' },
    { id: 'approved', stateId: invoice_state.approved, label: 'Goedgekeurd', className: 'approved' },
    { id: 'rejected', stateId: invoice_state.rejected, label: 'Geannuleerd', className: 'rejected' },
    { id: 'overdue', stateId: invoice_state.overdue, label: 'Achterstallig', className: 'overdue' }
  ];
  activeTabId: InvoiceTabId = 'all';

  constructor(private Router: Router) { }

  get activeTab(): InvoiceTab {
    return this.tabs.find(tab => tab.id === this.activeTabId) ?? this.tabs[0];
  }

  get dashboardInvoices(): InvoicesListItem[] {
    return this.invoices.filter(item =>
      item.status.id !== invoice_state.send && item.status.id !== invoice_state.paid
    );
  }

  get visibleInvoices(): InvoicesListItem[] {
    const invoices = this.activeTab.stateId === null
      ? this.dashboardInvoices
      : this.dashboardInvoices.filter(item => item.status.id === this.activeTab.stateId);

    return [...invoices]
      .sort((left, right) => this.dmyToTimestamp(right.invoice.date) - this.dmyToTimestamp(left.invoice.date));
  }

  selectTab(tabId: InvoiceTabId): void {
    this.activeTabId = tabId;
  }

  getInvoiceCount(stateId: number | null): number {
    if(stateId === null)
      return this.dashboardInvoices.length;

    return this.dashboardInvoices.filter(item => item.status.id === stateId).length;
  }

  getStatusClass(stateId: number): string {
    return this.tabs.find(tab => tab.stateId === stateId)?.className ?? '';
  }

  getStatusLabel(item: InvoicesListItem): string {
    return this.tabs.find(tab => tab.stateId === item.status.id)?.label ?? item.status.description;
  }

  openInvoice(invoiceId: number): void {
    this.Router.navigate(['invoicing', invoiceId]);
  }


  trackByInvoiceId(_index: number, item: InvoicesListItem): number {
    return item.invoice.id;
  }

  private dmyToTimestamp(date: string): number {
    const [day, month, year] = date.split('-').map(Number);
    return new Date(year, month - 1, day).getTime();
  }

  toInvoicing() {
    this.Router.navigateByUrl('invoicing');
  }
  showProject(projectId: number): void {
    this.Router.navigate(['projects', projectId]);
  }
}
